import { gsap } from 'gsap'


class MainVisual
{
  // ---------------------------------------------------------------------------------------------------------
	// --	MainVisual
	// ---------------------------------------------------------------------------------------------------------

  constructor(){

  }

  start()
  {
    //背景画像
    const bg = $('.detail-mv__bg')
    gsap.set(bg, {scaleX:1.15, scaleY:1.15, alpha:0})
    gsap.to(bg, 1.0, {
      alpha   :1,
      ease    :'none',
      delay   :0.5,
    })
    gsap.to(bg, 2, {
      scaleX  :1,
      scaleY  :1,
      delay   :0.5,
      ease    :'power2.out'
    })

    //プレイボタン
    if($('.detail-mv__play-btn-container').length>0)
    {
      const playBtnContainer = $('.detail-mv__play-btn-container')
      gsap.set(playBtnContainer, {alpha:0})
      gsap.to(playBtnContainer, 0.6, {
        alpha   :1,
        ease    :'none',
        delay   :1.0
      })
    }

    //COMINGSOON
    if($('.detail-mv__comingsoon').length>0)
    {
      const comingsoon = $('.detail-mv__comingsoon')
      gsap.set(comingsoon, {alpha:0})
      gsap.to(comingsoon, 0.6, {
        alpha   :1,
        ease    :'none',
        delay   :1.0
      })
    }

    //終了告知
    if($('.detail-mv__finished').length>0)
    {
      const finished = $('.detail-mv__finished')
      gsap.set(finished, {alpha:0})
      gsap.to(finished, 0.6, {
        alpha   :1,
        ease    :'none',
        delay   :1.0
      })
    }
  }
  
	// ---------------------------------------------------------------------------------------------------------
}

export default MainVisual